import { supabase } from "@/supabase";
import calcularMediaPorAlunoPorCompetencia from "@/utils/calcularMediaPorAlunoPorCompetencia";


export async function carregarNotasDosEstudantes(estudantes) {
    const { data, error } = await supabase
        .from('users')
        .select(`
        planos_notas!inner (
            id, nota, comentario, comentario_para_estudante, comentario_grupo, 
            planos_avaliacoes!inner (
                id, tipo, criterios_rubrica(id, criterio), nivel1, nivel2, nivel3, nivel4, titulo, forms_id, id_questao_com_nomes,
                 planos (
                    id, titulo, trimestre,
                        planos_aulas!inner(aula)
                    )
                )
            ) 
        )`)
        .eq('estudantes_turmas.idDaTurma', turma.value.idDaTurma)
        .eq('planos_notas.planos_avaliacoes.planos.planos_aulas.aula', turma.value.idDaAula)
        .not('planos_notas.planos_avaliacoes.planos', 'is', null)
        .order('nome', { ascending: true })
        .order('id', { ascending: false, foreignTable: 'planos_notas' });

    if (error) {
        console.log(error.message)
        return
    }
    return data;
}

export async function carregarDesempenhoPorCompetencia(estudantes, competencias) {
    const { data, error } = await supabase
        .from('planos_notas')
        .select(`estudante, nota, planos_avaliacoes!inner(criterios_rubrica(id, criterio), planos!inner(parecer_competencias!inner(id,competencia,disciplina)))`)
        .in('planos_avaliacoes.planos.parecer_competencias.id', competencias)
        .in('estudante', estudantes)
        .not('planos_avaliacoes.planos.parecer_competencias.id', 'is', null)


    if (error) {
        console.log(error.message)
        return
    }

    let desempenhoCompetencia = calcularMediaPorEstudanteECompetencia(data);
    let desempenhoCriterio = calcularMediaPorEstudanteECriterio(data)

    
    
    return {desempenhoCompetencia, desempenhoCriterio}
}



function calcularMediaPorEstudanteECompetencia(itens) {

        // {
        //     "estudante": 833,
        //         "nota": 60,
        //             "planos_avaliacoes": {
        //         "planos": {
        //             "parecer_competencias": {
        //                 "id": 187,
        //                     "competencia": "Analisar e comparar as principais teorias da filosofia da mente para avaliar suas contribuições e limitações no entendimento da relação entre mente e corpo, e a aplicabilidade dessas teorias na inteligência artificial e na compreensão da consciência.",
        //                         "disciplina": 1
        //             }
        //         },
        //         "criterios_rubrica": {
        //             "id": 1,
        //                 "criterio": "Construção do conhecimento"
        //         }
        //     }
        // }
    const agrupados = {};

    for (const item of itens) {
        if (item.nota > 0 && item.nota <= 100) {
            const estudanteId = item.estudante;
            const competenciaId = item.planos_avaliacoes.planos.parecer_competencias.id;
            const competenciaNome = item.planos_avaliacoes.planos.parecer_competencias.competencia;
            const disciplinaId = item.planos_avaliacoes.planos.parecer_competencias.disciplina;
            const tipoCriterio = item.planos_avaliacoes.criterios_rubrica.id;

            // Cria estrutura para o estudante se ainda não existe
            if (!agrupados[estudanteId]) {
                agrupados[estudanteId] = {
                    estudante: estudanteId,
                    competencias: []
                };
            }

            // Encontra ou cria estrutura para a competência
            let competencia = agrupados[estudanteId].competencias.find(
                c => c.id === competenciaId && c.disciplina === disciplinaId
            );
            if (!competencia) {
                competencia = {
                    id: competenciaId,
                    disciplina: disciplinaId,
                    competenciaNome: competenciaNome, 
                    notas: []
                };
                agrupados[estudanteId].competencias.push(competencia);
            }

            // Adiciona a nota à competência
            competencia.notas.push({ tipoCriterio: tipoCriterio, nota: item.nota });
        }
    }



    const desempenhoPorEstudante = [];
    Object.values(agrupados).forEach((estudante)=> {
        desempenhoPorEstudante.push({estudante: estudante.estudante, competencias: calcularMediaPorAlunoPorCompetencia(estudante)});

    })


    return desempenhoPorEstudante;


}

function calcularMediaPorEstudanteECriterio(itens) {
    const agrupados = itens.reduce((acc, item) => {
        if (item.nota > 0 && item.nota <= 100) {
            const estudanteId = item.estudante;
            const criterioId = item.planos_avaliacoes.criterios_rubrica.id;
            const criterioNome = item.planos_avaliacoes.criterios_rubrica.criterio;

            // Cria estrutura para o estudante se ainda não existe
            if (!acc[estudanteId]) {
                acc[estudanteId] = {
                    estudante: estudanteId,
                    criterios: []
                };
            }

            // Encontra ou cria estrutura para o critério
            let criterio = acc[estudanteId].criterios.find(c => c.id === criterioId);
            if (!criterio) {
                criterio = {
                    id: criterioId,
                    criterio: criterioNome,
                    notas: []
                };
                acc[estudanteId].criterios.push(criterio);
            }

            // Adiciona a nota à lista de notas do critério
            criterio.notas.push(item.nota);
        }
        return acc;
    }, {});

    // Calcula a média das notas para cada critério de cada estudante
    const resultados = Object.values(agrupados).map(estudante => {
        estudante.criterios = estudante.criterios.map(criterio => {
            const soma = criterio.notas.reduce((total, nota) => total + nota, 0);
            const media = soma / criterio.notas.length;
            return {
                id: criterio.id,
                criterio: criterio.criterio,
                desempenho: media
            };
        });
        return estudante;
    });

    return resultados;
}